import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { List } from 'immutable';

import { canAccess } from 'utils/PermissionHandler';

import { makeSelectUserPermissions } from '../../reducers/auth/selectors';
import { makeSelectUser } from '../../reducers/user/selectors';

const renderResult = (isAllowed, children, permissionDeniedComponent) => {
  if (typeof children === 'function') {
    return children(isAllowed);
  }

  return isAllowed ? children : !permissionDeniedComponent ? null : permissionDeniedComponent;
};

function CanRender({
  not,
  user,
  args,
  options,
  children,
  permission,
  userPermissions,
  // eslint-disable-next-line react/prop-types
  permissionDeniedComponent,
}) {
  if (!user) {
    return null;
  }

  const can = canAccess(userPermissions, permission, user, args, options);

  return renderResult(not ? !can : can, children, permissionDeniedComponent);
}

CanRender.propTypes = {
  not: PropTypes.bool,
  options: PropTypes.object,
  permission: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  args: PropTypes.object,
  user: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  userPermissions: PropTypes.instanceOf(List),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
};

const mapStateToProps = createStructuredSelector({
  user: makeSelectUser(),
  userPermissions: makeSelectUserPermissions(),
});

export default connect(mapStateToProps)(CanRender);
